// Client-side timeout for the logo upload requests (flag
// REACT_APP_SUPPLIER_UNAVAILABLE_ENABLED + REACT_APP_UPLOAD_CLIENT_TIMEOUT_MS,
// straks-lindring 14/9). Pure module: no flag reads here, so enviroment.ts
// can import the parser without a cycle. The AbortController wrapper that
// uses the value lives in supplierUnavailable.ts.
//
// Prod fact (14/9 19:47 DK): CreateAndUploadImageLogo took 300 676 ms and
// then failed because app117's Upload_Base64 hung for the API's full
// 300 s; the user watched a spinning dialog for 5 minutes. The API's own
// fail-fast (503 supplierUnavailable) is the first line; this timeout is
// the safety net for the case where the API itself does not answer.

// Recommended value (the API's own budget is shorter when its flag is on).
export const RECOMMENDED_UPLOAD_CLIENT_TIMEOUT_MS = 60_000;
// Guard rail: a typo ("60" meant as seconds) must never cancel every
// upload before the API can possibly answer. Values below this are lifted
// to it.
export const MIN_UPLOAD_CLIENT_TIMEOUT_MS = 5_000;

/**
 * The client timeout in ms, or undefined for "no timeout" - unset, empty,
 * not a number, zero or negative all mean none (byte-identical wire).
 * Positive values below MIN_UPLOAD_CLIENT_TIMEOUT_MS are lifted to it.
 */
export function parseUploadClientTimeoutMs(
  raw: string | undefined
): number | undefined {
  if (raw === undefined) return undefined;
  const trimmed = raw.trim();
  if (trimmed === "") return undefined;
  const value = Number(trimmed);
  if (!Number.isFinite(value) || value <= 0) return undefined;
  return Math.max(MIN_UPLOAD_CLIENT_TIMEOUT_MS, Math.round(value));
}
